// The bowie knife: "Ontario SP 10 Bowie knife" by HorusZ (sketchfab.com/HorusZ, CC-BY-4.0), split by
// scripts/import-bowie.mjs into the grip, the guard and the blade. A big knife: held with the index
// finger behind the guard and the long blade forward; its inspect turns it over into a reverse grip,
// pommel up out of the fist and the blade rising out to the right, back of the hand to the camera (like CS2).

import * as THREE from 'three';
import { straightKnifeLoader } from './straightKnife';

export const loadBowie = straightKnifeLoader({
  url: `${import.meta.env.BASE_URL ?? '/'}assets/models/bowie.glb`,
  colors: { grip: 0x0e0f12, guard: 0x1d1f24 },
  fitScale: 0.00016,
  index: { part: 'guard', from: 'middle', offset: 1600 },
  fistLength: 16000,
  edgeSide: -1,
  inspect: {
    // Like CS2: the fist raised left of centre with the back of the hand to the camera (the elbow
    // bends to get there): pommel up out of the fist, the long blade out to the right, turned in
    // the fist to show its flat.
    fist: new THREE.Vector3(-0.05, 0, -0.45),
    across: new THREE.Vector3(-0.75, 0.2, -0.6),
    knuckles: new THREE.Vector3(-1, 0, 0),
    palm: false,
    twist: Math.PI / 2,
    // Lifted a touch in the fist so the blade sits just above the forearm, which comes in from the right.
    turn: { axis: new THREE.Vector3(-0.612, 0.355, 0.707), angle: 0.3 },
    // A quarter of the inspect's wrist turn: the whole turn bends the hand and rolls the long blade
    // into the arm.
    wrist: 0.25,
  },
});
